import { createRoutine } from 'redux-saga-routines';
//////////////////////////////////////////////////

const CHANGE_ROUTE = 'CHANGE_ROUTE';
const SET_PAGE_NAME = 'SET_PAGE_NAME';
const SET_CURRENT_ROUTE = 'SET_CURRENT_ROUTE';

const changeRouteRoutine = createRoutine(CHANGE_ROUTE);
const setPageNameRoutine = createRoutine(SET_PAGE_NAME);
const setCurrentRouteRoutine = createRoutine(SET_CURRENT_ROUTE);

export {
  changeRouteRoutine,
  setPageNameRoutine,
  setCurrentRouteRoutine,
};
